/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 13:00:10 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getManyQualificationQuery = gql`
  query allQualifications(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: QualificationFilter
  ) {
    items: allQualifications(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
    }
    total: _allQualificationsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export default ({ client, params }) => {
  try {
    // account for pagination not being reduced on custom lists
    params.ids = params.ids.map(x => x.id);
    return client.query({
      query: getManyQualificationQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort && params.sort.field,
        sortOrder: params.sort && params.sort.order,
        page:
          params.pagination && params.pagination.page > 0
            ? params.pagination.page - 1
            : params.pagination.page,
        perPage: params.pagination && params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
